<div [formGroup]="group" [attr.class]="styleForm" [class.icon]="icon">
    <label *ngIf="label">{{ label }}</label>
    <div [class.has-icon]="icon" class="field">
        <div *ngIf="error && error.condition && error.message" class="form-error">{{ error.message }}</div>
        <i *ngIf="icon" [attr.class]="icon"
           [ngClass]="{ 'hasError': error && error.condition }"
        ></i>
        <div class="icon-container">
            <ng-content select=".icon-container"></ng-content>
        </div>
        <input
                [id]="id"
                [class.setMaj]="setMaj"
                [type]="type"
                [attr.tabindex]="index"
                [max]="max"
                [min]="min"
                class="text-field e2e-text-field"
                [ngClass]="{ 'hasError': error && error.condition }"
                [attr.placeholder]="placeholder"
                [formControlName]="controlName"
                [maxlength]="maxlength"
                (blur)='onBlur($event);modifChar();'
                (keyup)="onChange($event); onKeyup($event)"
                (keypress)="testChar($event)"
                (focus)="onFocus($event)"
                [required]="required"
                #field>
    </div>
</div>
